<template>
  <div class="card">
    <div class="icon">
      <img v-if="this.iconSrc != null" :src="this.iconSrc" :alt="this.title">
      <i v-if="this.iconClass != null" v-bind:class="this.iconClass"></i>
    </div>
    <div class="card-title">
      <h2>{{ this.title }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: ['iconSrc', 'iconClass', 'title', 'desc', 'ctaText', 'ctaLink']
}
</script>

<style scoped>
.card {
  border-radius: 0.25rem;
  border: none;
  -webkit-transition: all 300ms ease-in-out;
  -moz-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
}

.card:hover {
  -webkit-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 10px -1px rgba(0,0,0,0.3);
}

.card .icon {
  height: 92px;
  margin-top: 35px;
  text-align: center;
  display: flex; 
}

.card .icon img {
  max-height: 100%;
  margin: auto auto 0 auto;
}

.card .icon i {
  color: var(--color-green-1);
  font-size: 4em;
  margin-left: auto;
  margin-right: auto;
}

.card .card-title {
  position: relative;
  text-align: center;
}

.card h2 {
 text-align: center;
 font-size: 20px;
 margin-top: 18px;
}

/* .card h2:before {
  position: absolute;
  content: '';
  top: 0;
  height: 2px;
  width: 40px;
  border-top: 3px solid var(--color-green-1);
  z-index: 1;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
} */

.card p {
  padding-left: 18px;
  padding-right: 18px;
  padding-bottom: 38px;
  text-align: center;
}

a.btn {
  margin-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
}
</style>
